import React from 'react';
import SingleCare from '../../../images/singlecare.png';
import wallmart from '../../../images/wallmart-card.png';
import './card-styles.css';

export function WalmartCardFront({ bin, pcn, groupNumber, memberId }) {
    return (
        <div className="w-full max-w-[500px] min-h-[300px] rounded-2xl overflow-hidden bg-[#313131] flex flex-col justify-between relative">
            {/* Side Icon */}
            <div className="absolute left-0 top-0 w-20 h-20 sm:w-[50px] sm:h-[50px] card-side-icon" />

            {/* Card Header */}
            <div className="pt-5 px-3.5">
                <div className="flex justify-between items-center text-sm font-medium text-white pl-[50px] font-urbanist">
                    <img src={SingleCare} className="max-w-full h-auto" alt="SingleCare Logo" />
                    <div className="text-sm font-medium">Pharmacy Savings</div>
                </div>
                <div className="bg-[#1e76d0] text-white uppercase text-center font-bold text-sm py-1.5 px-1.5 mt-2 font-urbanist">
                    Save on your prescription medications
                </div>
            </div>

            {/* Card Body */}
            <div className="py-2.5 px-6">
                <div className="font-semibold text-xl w-full text-white text-center mb-2 font-urbanist">
                    Available at<br />
                    <img src={wallmart} alt="Walmart Logo" className="inline-block max-h-[30px] mt-1" />
                </div>
                <div className="text-white font-normal text-[28px] leading-[1.3] sm:text-lg font-urbanist">
                    <div>Member ID: <span>{memberId}</span></div>
                    <div>Bin: <span>{bin}</span></div>
                    <div>Group: <span>{groupNumber}</span></div>
                    <div>PCN: <span>{pcn}</span></div>
                </div>
            </div>

            {/* Card Footer */}
            <div className="bg-[#f19f57] px-3.5 py-2 text-sm text-[#313131] font-normal font-urbanist">
                <div className="font-bold">
                    This card is not insurance.
                </div>
            </div>
        </div>
    );
}

export function WalmartCardBack() {
    return (
        <div className="w-full max-w-[500px] min-h-[300px] rounded-2xl overflow-hidden bg-[#313131] flex flex-col justify-between">
            {/* Card Body */}
            <div className="flex flex-wrap p-3 sm:p-2 pt-2.5 text-center leading-none">
                <h3 className="text-[#1e76d0] text-sm px-7.5 pb-1 w-full mb-1.5 text-white font-urbanist">
                    Available savings at Walmart pharmacies<br />on FDA-approved prescription medications.*
                </h3>
                <div className="w-full text-[11px] text-white font-urbanist">
                    <p className="mb-1.5 sm:mb-0.5"><strong>Customer Instructions:</strong> Show this card to your Walmart pharmacist to receive savings. For more information, call toll-free at 1-866-978-1091.</p>
                    <p className="mb-1.5 sm:mb-0.5"><strong>Pharmacist Instructions:</strong> This card entitles the cardholder to all prescription benefits associated with the BIN, GRP, and PCN codes. For help processing, please call toll-free at 1-800-974-3135.</p>
                </div>
                <h4 className="text-xs block w-full text-white mb-1.5 mt-1 font-urbanist">
                    This card is accepted at <img src={wallmart} alt="Walmart" className="inline max-h-[15px] -mb-[3.5px] mx-1" />
                </h4>
                <p className="text-[11px] w-[90%] mx-auto text-white font-urbanist">
                    Visit <a href="https://singlecare.com/honestdiscounts" target="_blank" rel="noopener noreferrer" className="text-[#1e76d0]">singlecare.com/honestdiscounts</a> for more information, pricing and participating pharmacies.
                </p>
                <p className="text-[11px] w-[90%] mx-auto mb-2 text-white font-urbanist">
                    This card is not insurance.<br />Your privacy is protected. We do not rent or sell your personal information.<br />By using this card you have agreed to the terms and conditions found at singlecare.com/terms-and-conditions.
                </p>
                <div className="flex text-[9px] w-full justify-between text-white mb-2 font-urbanist">
                    <span>*Subject to pharmacist discretion</span>
                    <span>&copy; 2019 SingleCare Administrators</span>
                    <span>SCHD_0819_WM_CA</span>
                </div>
            </div>
        </div>
    );
}
